////////////*** HELPER FUNCTION ***////////////

function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

function getViewportHeight() {
  return Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );
}

function getScrollTop() {
  return window.pageYOffset !== undefined
    ? window.pageYOffset
    : (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
}

function isInViewport(element) {
  if (element === null) return false; // Ensure the element exists before proceeding

  var rect = element.getBoundingClientRect();
  var elementTop = rect.top + getScrollTop();
  var elementBottom = elementTop + rect.height;
  var viewportTop = getScrollTop();
  var viewportBottom = viewportTop + getViewportHeight();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

////////////*** END HELPER FUNCTION ***////////////

window.addEventListener("scroll", checkVideoReviewViewport);
document.addEventListener("DOMContentLoaded", checkVideoReviewViewport);

function checkVideoReviewViewport() {
  const videoReview = document.querySelector(
    ".new-video-reviews.desktop--only"
  );
  const yotpoWidget = document.querySelector(".yotpo-main-widget");

  const hasElementInViewport =
    (videoReview && isInViewport(videoReview)) ||
    (yotpoWidget && isInViewport(yotpoWidget));

  if (!window.runExperiment100474766 && hasElementInViewport) {
    window.runExperiment100474766 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100474766"]);
    console.log(
      "Convert - Product Video Reviews - DESKTOP - 100474766 - Experiment Activated"
    );
  }
}

window.addEventListener("scroll", checkProductUpsellViewport);
document.addEventListener("DOMContentLoaded", checkProductUpsellViewport);

function checkProductUpsellViewport() {
  const productUpsell = document.querySelector(".product__upsell");

  const hasElementInViewport = productUpsell && isInViewport(productUpsell);

  if (!window.runExperiment100494362 && hasElementInViewport) {
    window.runExperiment100494362 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100494362"]);
    console.log("Convert - 30% OFF Upsell - 100494362 - Experiment Activated");
  }
}

document.addEventListener("cart:open", () => {
  if (!window.runExperiment100479186) {
    window.runExperiment100479186 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100479186"]);
    console.log(
      "Convert - Cart Drawer Upsell - 100479186 - Experiment Activated"
    );
  }

  if (!window.runExperiment100494362) {
    window.runExperiment100494362 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100494362"]);
    console.log("Convert - 30% OFF Upsell - 100494362 - Experiment Activated");
  }

  if (!window.runExperiment100496357) {
    window.runExperiment100496357 = 1;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100496357"]);
    console.log("Convert - Cart Drawer Optimization - 100496357 - Experiment Activated");
  }
});
